@use 'ui/styles/core-tokens' as core;

.formNavigation {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
